import { Deserializable } from "./deserializable.model";

/* export interface Tipo {
    id_proced?: number;
    nomeTipo: string;
} */

export class Tipo implements Deserializable {
  public _id?: number;
  public nomeTipo?: string;
  public createdAt: Date;
  public updatedAt: Date;
  public icone?: string;

  deserialize(input: any): this {
    return Object.assign(this, input);
  }
}
